import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import ButtonBase from "@material-ui/core/ButtonBase";
import ZoomInIcon from "@material-ui/icons/ZoomIn";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  zoomed: {
    width: "60vw",
    height: "70vh",
  },
  normal: {
    width: "100%",
    height: 200,
  },
  root: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
  image: {
    position: "relative",
    height: 200,
  },
  focusVisible: {},
  imageButton: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundPosition: "center 40%",
  },
  imageBackdrop: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create("opacity"),
  },
  imageTitle: {
    position: "relative",
    padding: `${theme.spacing(2)} ${theme.spacing(4)} calc(${theme.spacing(
      1
    )} + 6px)`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    bottom: -2,
    left: "calc(50% - 9px)",
    transition: theme.transitions.create("opacity"),
  },
  zoomDiv: {
    width: 60,
    height: 60,
    backgroundColor: theme.palette.common.white,
    borderRadius: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: "0.8",
  },
}));

interface DocumentImageProps {
  image: string;
}

export const DocumentImage = (props: DocumentImageProps) => {
  const classes = useStyles();
  const { image } = props;
  const [zoomed, setZoomed] = useState(false);

  const zoom = () => setZoomed(!zoomed);

  return (
    <>
      <Modal className={classes.modal} open={zoomed} onClose={zoom}>
        <img className={classes.zoomed} alt="document" src={image} />
      </Modal>
      <Box border={1}>
        <div className={classes.root}>
          <ButtonBase
            onClick={zoom}
            focusRipple
            key="DocumentImage"
            className={classes.image}
            focusVisibleClassName={classes.focusVisible}
            style={{
              width: "100%",
            }}
          >
            <span
              className={classes.imageSrc}
              style={{
                backgroundImage: `url(${image})`,
              }}
            />
            <span className={classes.imageBackdrop} />
            <span className={classes.imageButton}>
              <div className={classes.zoomDiv}>
                <ZoomInIcon color="primary" />
              </div>
            </span>
          </ButtonBase>
        </div>
      </Box>
    </>
  );
};
